import React from 'react';
import MilestoneInt from '../MilestoneInt/MilestoneInt';
import ChecklistInt from '../ChecklistInt/ChecklistInt';
import ToolsInt from '../ToolsInt/ToolsInt';
import TasksInt from '../TasksInt';
import LeaderboardInt from '../LeaderboardInt';
import OverViewInt from "../OverviewInt/OverviewInt";
import StarYearInit from "../starYearInit/starYearInit";
function ContentInt(props) {
	const { data, activeTab, swipeActions, setNav,  scrollNav } = props;
	switch (activeTab?.key) {
		case 'overview':
			return <OverViewInt
				data={data}
				swipeActions={swipeActions}
				scrollNav={scrollNav} />;
		case 'star':
			return <StarYearInit
				data={data}
				swipeActions={swipeActions}
				scrollNav={scrollNav} />;
		case 'milestones':
			return <MilestoneInt
				data={data?.peakDayCard}
				swipeActions={swipeActions} />;
		case 'tools':
			return <ToolsInt
				data={data?.toolsPage}
				bottomCard={data?.bottomCard}
				campaignOrg={data?.campaignOrg}
				swipeActions={swipeActions} />;
		case 'checklist':
			return (
				<ChecklistInt
					checklist={data?.checklist}
					bottomCard={data?.bottomCard}
					campaignOrg={data?.campaignOrg}
					swipeActions={swipeActions}
					scrollNav={scrollNav} />
			);
		case 'leaderboard':
			return (
				<LeaderboardInt
					data={data?.rankingsPage}
					myorg={data?.campaignOrg?.orgName}
					swipeActions={swipeActions}
					scrollNav={scrollNav}
				/>
			);
		case 'tasks':
			return (<TasksInt
				data={data?.statCard}
				bottomCard={data?.bottomCard}
				stickersCard={data?.stickersCard}
				campaignOrg={data?.campaignOrg}
				scrollNav={scrollNav}
				swipeActions={swipeActions}/>);
		default:
			return <div>nothing to show</div>;
	}
}

export default ContentInt;
